import { render, staticRenderFns } from "./TablaProductos.vue?vue&type=template&id=56f173aa&scoped=true&"
import script from "./TablaProductos.vue?vue&type=script&lang=js&"
export * from "./TablaProductos.vue?vue&type=script&lang=js&"
import style0 from "./TablaProductos.vue?vue&type=style&index=0&id=56f173aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56f173aa",
  null
  
)

export default component.exports